import EasyCardApi from '@apis/easyCard/EasyCardApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const easyCardQueries = createQueryKeys('easyCard', {
    payU: () => ({
        queryKey: ['payU'],
        queryFn: () => EasyCardApi.getPayUInfo(),
    }),
});

export default easyCardQueries;
